import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { PrimaryButton } from 'shared/components/button'
import FormInput from 'shared/components/form-input'
import { BadRequest } from 'shared/errors/bad-request'
import { registerCommunity } from '../api/community-api'

function RegisterForm({ showThankYou, disabled }: { showThankYou: () => void; disabled: boolean }) {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  const { communityPath } = router.query

  async function register() {
    try {
      setIsLoading(true)
      await registerCommunity(
        email,
        `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${window.location.host}/community/${communityPath}`,
      )
      setIsLoading(false)
      showThankYou()
    } catch (e) {
      setIsLoading(false)
      if (e instanceof BadRequest) {
        if (e.errors.fields.email) {
          setEmailError(e.errors.fields.email.join('\n'))
        }
      }
    }
  }

  function changeEmail(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value)
  }

  return (
    <>
      <FormInput
        key="email"
        type="email"
        value={email}
        className="flex-auto"
        label={t('global.email_address')}
        onChange={changeEmail}
        maxLength={180}
        error={emailError}
        disabled={disabled}
      />
      <PrimaryButton key="register" isLoading={isLoading} onClick={register} disabled={disabled}>
        {t('join_form.button.register.title')}
      </PrimaryButton>
    </>
  )
}

export default RegisterForm
